import { render, staticRenderFns } from "./FoamBoxRightSVG.vue?vue&type=template&id=0ff53f9a&scoped=true"
import script from "./FoamBoxRightSVG.vue?vue&type=script&lang=js"
export * from "./FoamBoxRightSVG.vue?vue&type=script&lang=js"
import style0 from "./FoamBoxRightSVG.vue?vue&type=style&index=0&id=0ff53f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff53f9a",
  null
  
)

export default component.exports